import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/Common/Dialog';

export default function ProcessionPopup({
  onClose,
}) {
  return (
    <Dialog
      open
      title="新廣告注意事項"
      content={(
        <div>
          <div>
            <span style={{ fontWeight: 'bold' }}>
              儲值餘額：
            </span>
            <span>
              請在發送上稿需求前完成儲值，廣告才能順利上線
            </span>
          </div>
          <div>
            <span style={{ fontWeight: 'bold' }}>
              賣場狀態：
            </span>
            <span>
              賣場串接需預留十四個工作天作業
            </span>
          </div>
        </div>
      )}
      submitText="我瞭解了"
      onSubmit={onClose}
      onClose={onClose}
    />
  );
}

ProcessionPopup.propTypes = {
  onClose: PropTypes.func,
};

ProcessionPopup.defaultProps = {
  onClose: () => {},
};
